import { render, staticRenderFns } from "./panThumb.vue?vue&type=template&id=24256352&scoped=true&"
import script from "./panThumb.vue?vue&type=script&lang=js&"
export * from "./panThumb.vue?vue&type=script&lang=js&"
import style0 from "./panThumb.vue?vue&type=style&index=0&id=24256352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24256352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24256352')) {
      api.createRecord('24256352', component.options)
    } else {
      api.reload('24256352', component.options)
    }
    module.hot.accept("./panThumb.vue?vue&type=template&id=24256352&scoped=true&", function () {
      api.rerender('24256352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personalCenter/components/panThumb.vue"
export default component.exports